import { pick } from 'lodash'
import { createSelector } from 'reselect'

import { getAppName } from '../../../helpers/businessUnitsHelper'
import { getReverseDomain } from '../../../redux/account/selectors'

// Sub-Selectors
const apps = state => state.dashboardReducer.dashboard.appsData
export const getCountries = state => state.dashboardReducer.dashboard.countriesData
export const getGraphs = state => state.dashboardReducer.dashboard.graph.graphData
export const getGraphKeys = state => state.dashboardReducer.dashboard.graph.keys
export const getGraphFormat = state => state.dashboardReducer.dashboard.graph.format
export const getColors = state => state.dashboardReducer.dashboard.colors
export const getBars = state => state.dashboardReducer.dashboard.barsData.data
export const getBarsFormat = state => state.dashboardReducer.dashboard.barsData.format

export const getPaymentflow = state => state.dashboardReducer.dashboard.flowData.data
export const getPaymentFormat = state => state.dashboardReducer.dashboard.flowData.format
export const getPaymentStage = state => state.dashboardReducer.dashboard.paymentStage
export const getMetrics = state => state.dashboardReducer.dashboard.metrics
export const getSelectedBar = state => state.dashboardReducer.dashboard.bar

export const selectedApps = state => state.dashboardReducer.dashboard.apps || []
export const getSelectedCountries = state => state.dashboardReducer.dashboard.countries
export const getDatesData = state => pick(state.dashboardReducer.dashboard, ['from', 'to', 'granularity'])

// selectors
export const getApps = createSelector(
  apps,
  getReverseDomain,
  (apps, reverseDomain) => (apps
    ? apps.map(({ id, status }) => ({
      status,
      key: id,
      value: getAppName(reverseDomain, id)
    }))
    : [])
)
